<template>
  <sc-flex :is-column="true" :gap="4">
    <sc-layout-navitem @click="$router.push('/')" icon="arrow-left"
      >Overview</sc-layout-navitem
    >
    <sc-layout-navitem-separator></sc-layout-navitem-separator>
    <sc-layout-navitem
      @click="$router.push(`/admin-dashboard/${companyHashId}`)"
      :is-active="$route.name === 'admin-dashboard'"
      icon="user-circle"
      >Dashboard</sc-layout-navitem
    >
    <sc-layout-navitem
      @click="$router.push(`/admin-documents/${companyHashId}`)"
      :is-active="$route.name === 'admin-documents'"
      icon="files"
      >Documents</sc-layout-navitem
    >
    <sc-layout-navitem
      @click="onMessagesClick"
      :is-active="$route.name === 'messages'"
      icon="chat"
      >Messages</sc-layout-navitem
    >
    <sc-layout-navitem
      v-if="reviewAndExportEnabled"
      @click="$router.push(`/review-export/${companyHashId}`)"
      :is-active="$route.name === 'review-export'"
      icon="list"
      >Review & Export</sc-layout-navitem
    >
  </sc-flex>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import endsWith from 'lodash/endsWith';
import isEmpty from 'lodash/isEmpty';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';
import AdminClientsMixin from '../mixins/AdminClientsMixin';

export default {
  name: 'NavigationClient',
  props: {
    currentCompanyId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      number: 0,
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'isAdvisor',
      'navigationItems',
      'user',
      'currentFirm',
    ]),
    ...mapState('companies', ['companies']),
    companiesWithAdminView() {
      return this.getCompaniesWithAdminView(this.companies);
    },
    allowTemplateChanges() {
      return (
        this.user &&
        this.user.firm_access !== 'basic' &&
        (!this.templateDisabledForFirmGroups ||
          this.user.firm_access !== 'group') &&
        this.user.firm_access === 'partner'
      );
    },
    hasEnabledFeatures() {
      return Boolean(
        this.newTaxReturnDeliveryEnabled ||
          this.allActivitiesEnabled ||
          this.signatureRequestsEnabled ||
          this.todoTasksEnabled,
      );
    },
    companyHashId() {
      const selectedCompany = this.companies.find(
        company => company.id === this.currentCompanyId,
      );

      return selectedCompany ? selectedCompany.hash_id : undefined;
    },
  },
  mixins: [AdminClientsMixin, FirmPreferenceMixins],
  methods: {
    isEmpty,
    logout() {
      this.$store.dispatch('userSignOut');
    },
    endsWith,
    goHome() {
      const homeUrl = this.user.is_advisor ? '/overview' : '/';

      return this.$router.push(homeUrl);
    },
    onMessagesClick() {
      this.$router.push(`/messages/${this.companyHashId}`);
    },
    async updateDefaultCompany(companyId) {
      const company = this.companies.find(c => companyId === c.id);

      this.$store.dispatch('setDefaultCompany', { companyId });
      this.$store.dispatch('resetTiles', {
        hashId: company.hash_id,
        clientName: company.name
          .replaceAll(' ', '-')
          .replaceAll(',', '')
          .replaceAll('#', ''),
      });

      this.$router.push({
        name: this.$router.currentRoute.name,
        params: {
          hash:
            company.name
              .replaceAll(' ', '-')
              .replaceAll(',', '')
              .replaceAll('#', '') +
            '-' +
            company.hash_id,
        },
      });
    },
  },
};
</script>
